import { useCallback } from 'react';
import { Note } from 'app/components/common/AdminNotes/AdminNotes';
import { useReferralListSlice } from 'app/pages/referral-list/slice';

interface UseNotesByReferralProps {
  referralId: string | null;
}

export const useNotesByReferral = ({ referralId }: UseNotesByReferralProps) => {
  const { useNoteListByReferralQuery, useCreateReferralNoteMutation } = useReferralListSlice();
  
  const { data: notes = [], isLoading: isLoadingNotes } = useNoteListByReferralQuery(
    { referralId: referralId },
    { skip: !referralId }
  );
  
  const [createNote, { isLoading: isCreatingNote }] = useCreateReferralNoteMutation();

  const handleAddNote = useCallback(async (content: string) => {
    if (!referralId || !content.trim()) return;

    try {
      await createNote({
        referralId:referralId,
        data: { text: content.trim() }
      }).unwrap();
    } catch (error) {
      console.error('Error adding note:', error);
    }
  }, [referralId, createNote]);

  return {
    notes,
    isLoading: isLoadingNotes || isCreatingNote,
    handleAddNote
  };
}; 